"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var TrashCan = function TrashCan(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 21 21"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    d: "M14.7384026,4.60575104 L14.7384026,15.6576997 C14.7323309,16.6726484 13.911051,17.4939284 12.8961022,17.5 L12.8961022,17.5 L3.68460062,17.5 C2.66965184,17.4939284 1.84837194,16.6726484 1.8423003,15.6576997 L1.8423003,15.6576997 L1.8423003,4.60575104 L14.7384026,4.60575104 Z M11.0593625,8.29035163 L9.2170622,8.29035163 L9.2170622,13.8153994 L11.0593625,13.8153994 L11.0593625,8.29035163 Z M7.36364106,8.29035163 L5.53246115,8.29035163 L5.52690089,13.8153994 L7.36364106,13.8153994 L7.36364106,8.29035163 Z M11.0538016,0 L11.0538016,1.84230035 L16.5807025,1.84230035 L16.5807025,3.68274728 L0,3.68274728 L0,1.84230035 L5.52690082,1.84230035 L5.52690082,0 L11.0538016,0 Z"
  }));
};

TrashCan.propTypes = {};
var _default = TrashCan;
exports["default"] = _default;